module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDAiIGhlaWdodD0iMTQ0IiB2aWV3Qm94PSIwIDAgNTQwIDE0NCI+PHJlY3Qgd2lkdGg9IjUzOSIgaGVpZ2h0PSIxNDQiIHg9IjExOS4zMjciIHk9IjYyNDYiIGZpbGw9IiNGRkJCOEQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgcng9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTkgLTYyNDYpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/time-attendance-bg.svg
// module id = ua2n
// module chunks = 0